// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcm_a bhc_b bhc_uy bhc_rt bhc_ru bhc_vs","PanelFooter--link":"bcm_b"};